<template>
  <div :style="{ '--color-fondo': ColorFondo }" class="contenedor-pagina">
    <HomeAfiliado v-if="EsAfiliado" />
    <!-- <HomeVisita v-else /> -->
  </div>
</template>

<script>
import { environment } from "../../environments/environment";
import { mapState } from "vuex";

import { Api } from "../../api";
import {default as HomeAfiliado} from '../../components/cliente/afiliado/Home.vue';
//import {default as HomeVisita} from '../../components/cliente/visita/Home.vue';
import { Util } from "../../util";

const COLORES_MODA = [
  "var(--color-moda-a)",
  "var(--color-moda-b)",
  "var(--color-moda-c)",
];

export default {
  components: {
    HomeAfiliado,
    //HomeVisita,
  },
  data() {
    return {
      categoriaActual: null,
      display: false,
      filtroBeneficio: null,
      filtroLocalidad: null,
      idBeneficioInfo: "",
      idUsuario: null,
      renderize: false,
      renderizeInfo: false,
      modalSuscripcionesVisible: false,
      token: null,
      urlImagenCompania: environment.API_SB_URL + 'images/logos/' + localStorage.getItem('logoCompania'),
    };
  },
  computed: {
    ColorFondo() {
      if (this.categoria) return this.categoria.color;
      else return "var(--color-moda-a)";
    },
    EsAfiliado() {
      return this.idUsuario != null && this.token != null;
    },
    // Computed properties de vuex
    // Datos compartidos en toda la app
    ...mapState({
      beneficios: (state) => state.beneficios,
      categoria: (state) => state.categoria,
      categorias: (state) => state.categorias,
      subcategoria: (state) => state.subcategoria,
    }),
  },
  watch: {
    categoria(nueva, vieja) {
      if (nueva === vieja) return;

      this.categoriaSeleccionada(nueva);
    },
  },
  methods: {
    abrirModalSuscripciones() {
      this.modalSuscripcionesVisible = true;
    },
    categoriaSeleccionada(cat) {
      this.categoriaActual = cat;
      this.filtroBeneficio = null;
      this.filtroLocalidad = null;
    },
    cerrarModalSuscripciones() {
      this.modalSuscripcionesVisible = false;
    },
    colorearCategorias() {
      this.categorias.forEach((c) => {
        const nombreMinusculas = c.name.toLowerCase();

        // Si el search devuelve cero, significa que la subcadena está al inicio de la cadena
        if (nombreMinusculas.search("hombre") == 0)
          c.color = "var(--color-moda-h)";
        else if (nombreMinusculas.search("mujer") == 0)
          c.color = "var(--color-moda-m)";
        else if (nombreMinusculas.search("niñ") == 0)
          c.color = "var(--color-moda-n)";
        else c.color = Util.elementoAleatorio(COLORES_MODA);
      });
    },
    escribiendoNombreBeneficio(event) {
      this.filtroBeneficio = event.target.value;
    },
    escribiendoNombreLocalidad(event) {
      this.filtroLocalidad = event.target.value;
    },
    iniciarCategorias() {
      Api.Categoria.getTodas().then((response) => {
        const categorias = response.data;

        // Usada para limpiar la categoría seleccionada
        const categoriaTodas = {
          id: 0,
          name: "Todas",
        };

        // Agregarla al medio
        categorias.splice(Math.floor(categorias.length / 2), 0, categoriaTodas);

        this.$store.commit("cargarCategorias", categorias);

        if (!this.categoria)
          // Seleccionar categoría de todas
          this.$store.commit("cambiarCategoria", categoriaTodas);

        this.colorearCategorias();
      });
    },
    subcategoriaSeleccionada() {
      this.filtroBeneficio = null;
      this.filtroLocalidad = null;
    },
  },
  mounted() {    
    this.token = localStorage.getItem("token");
    this.idUsuario = localStorage.getItem("iduser");
    const idUsuarioSB = localStorage.getItem("usersb");
    
    if(!localStorage.getItem("dni") && !localStorage.getItem("iduser") && !localStorage.getItem("user")){
      this.$router.push("/");
    }

    if (idUsuarioSB) {
      Api.General.getLogoSB(idUsuarioSB).then((response) => {
        if (response.data) this.urlImagenCompania = response.data;
      });
    }

    if (!this.categorias) this.iniciarCategorias();
  },
};
</script>

<style scoped>
.contenedor-pagina {
  position: relative;
  min-height: 100vh;
  background-color: var(--color-fondo);
}

h3 {
  margin: 40px 0 0;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.shadow2 {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2),
    0px 4px 5px 0px rgba(0, 0, 0, 0.14), 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
  transition: box-shadow 0.28s cubic-bezier(0.4, 0, 0.2, 1);
}

.shadow2:hover {
  box-shadow: 0px 11px 15px -7px rgba(0, 0, 0, 0.2),
    0px 24px 38px 3px rgba(0, 0, 0, 0.14), 0px 9px 46px 8px rgba(0, 0, 0, 0.12);
}

/* ************************************************************************ */
/* ******************* Media Queries ************************************** */
/* ************************************************************************ */

/* Extra small devices (portrait phones, less than 576px) */
@media screen and (max-width: 575px) {
  .container {
    padding: 0;
  }
}
</style>
